"use strict";
export const CarouselsMock = (mock) => {
  mock.onGet("/api/v1/apps/carousels").reply((config) => {
    let _response = {
      "model": "data.set",
      "datas": [
        {
          "model": "carousel",
          "tip": "\u591A\u5E73\u53F0 | \u5B9A\u65F6\u4EFB\u52A1 | \u4E00\u952E\u83B7\u53D6",
          "title": "\u5E97\u94FA\u62A5\u8868\u81EA\u52A8\u83B7\u53D6 \u518D\u591A\u5E97\u94FA\u4E0D\u7528\u6101",
          "btnStr": "\u9650\u65F6\u514D\u8D39",
          "btnUrl": "https://www.baidu.com/",
          "bgImg": "",
          "bgUrl": ""
        },
        {
          "model": "carousel",
          "tip": "\u8BF4\u8D70\u5C31\u8D70\u7684\u65C5\u884C \u53EA\u5DEE\u4E00\u4E2A\u8DE8\u5883\u536B\u58EB",
          "title": "\u4E13\u6CE8\u8DE8\u5883\u7535\u5546\u8D26\u53F7 \u5B89\u5168\u8FD0\u8425\u89E3\u51B3\u65B9\u6848",
          "btnStr": "\u4E24\u5206\u949F\u4E86\u89E3\u8DE8\u5883\u536B\u58EB \u25B6",
          "btnUrl": "https://www.kuajingvs.com/help-kjvs",
          "bgImg": "https://www.kuajingvs.com/wp-content/uploads/2020/07/indexbanner.jpg",
          "bgUrl": ""
        },
        {
          "model": "carousel",
          "tip": "\u591A\u5E73\u53F0 | \u5B9A\u65F6\u4EFB\u52A1 | \u4E00\u952E\u83B7\u53D6",
          "title": "\u5E97\u94FA\u62A5\u8868\u81EA\u52A8\u83B7\u53D6 \u518D\u591A\u5E97\u94FA\u4E0D\u7528\u6101",
          "btnStr": "\u9650\u65F6\u514D\u8D39",
          "btnUrl": "https://www.baidu.com/",
          "bgImg": "",
          "bgUrl": ""
        },
        {
          "model": "carousel",
          "tip": "",
          "title": "",
          "btnStr": "",
          "btnUrl": "",
          "bgImg": "https://www.kuajingvs.com/wp-content/uploads/2020/01/indexbanner3.jpg",
          "bgUrl": "https://www.kuajingvs.com/"
        }
      ],
      "total": 3
    };
    return [200, _response];
  });
};
